import { getApiUrl } from "backend-routes";
import { EndpointAppBuilder } from "core/src/store/store.types";
import { BaseEtlImportSchema, EtlImport } from "etl/types";
import { HttpVerb } from "types/src/specific";
import { TriggerFiltersTagsEnum } from "../formStep/triggerFilters.endpoints";

export enum EtlDataTagsEnum {
	SELECTED_ETL_IMPORT = "SelectedEtlImport",
}

export const getEtlDataEndpoints = (builder: EndpointAppBuilder) => ({
	getSelectedEtlImport: builder.query<EtlImport, { uuid: string }>({
		query: ({ uuid }) => {
			return {
				// url: `${EtlApiTarget.ETL_IMPORTS_API}/${uuid}`,
				uuid,
				schema: BaseEtlImportSchema,
				method: HttpVerb.GET,
			};
		},
		async onCacheEntryAdded(
			{ uuid },
			{ updateCachedData, cacheDataLoaded, dispatch }
		) {
			if (!uuid) return;

			try {
				const fullUrl = `${getApiUrl().mercureUrl}?topic=/etl_imports/${uuid}`
				const eventSource = new EventSource(fullUrl);

				await cacheDataLoaded;

				eventSource.onopen = () => {
					console.log("SSE connecté au topic:", fullUrl);
				};

				eventSource.onmessage = (event) => {
					try {
						const data = JSON.parse(event.data);

						updateCachedData(() => {
							return data;
						})

						// Invalider le tag lié à cet uuid pour rafraîchir les dépendants
						dispatch({
							type: "etlApi/invalidateTags",
							payload: [{ type: TriggerFiltersTagsEnum.GENERAL, id: uuid }],
						});

					} catch (error) {
						console.log("Message brut reçu:", event.data);
						console.log("Erreur parsing JSON:", error);
					}
				};

				eventSource.onerror = (event) => {
					console.error("Erreur SSE", event);
				};
			} catch (error) {
				console.error("Erreur SSE", error);
			}
		},
		providesTags: (_result, _error, { uuid }) => [{ type: EtlDataTagsEnum.SELECTED_ETL_IMPORT, id: uuid }],
	}),
	updateSelectedEtlImport: builder.mutation<EtlImport, { uuid: string, data: Partial<EtlImport> }>({
		query: ({ uuid, data }) => {
			return {
				uuid,
				schema: BaseEtlImportSchema,
				method: HttpVerb.PATCH,
				data,
			};
		},
		invalidatesTags: (_result, _error, { uuid }) => [{ type: EtlDataTagsEnum.SELECTED_ETL_IMPORT, id: uuid }],
	}),
});
